import { render, staticRenderFns } from "./MainScreen.vue?vue&type=template&id=04f225be&scoped=true&"
import script from "./MainScreen.vue?vue&type=script&lang=js&"
export * from "./MainScreen.vue?vue&type=script&lang=js&"
import style0 from "./MainScreen.vue?vue&type=style&index=0&id=04f225be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f225be",
  null
  
)

export default component.exports